import { Palette, Notifications, Photo, Keyboard, Settings, Memory } from "@mui/icons-material";
import type { ReactNode } from "react";

export interface GroupMeta {
  id: string;
  title: string;
  icon: ReactNode;
}

export const SETTING_GROUPS: GroupMeta[] = [
  { id: "appearance", title: "화면 설정", icon: <Palette fontSize="small" /> },
  { id: "notification", title: "알림 설정", icon: <Notifications fontSize="small" /> },
  { id: "image", title: "이미지 뷰어 설정", icon: <Photo fontSize="small" /> },
  { id: "shortcut", title: "단축키", icon: <Keyboard fontSize="small" /> },
  { id: "etc", title: "기타 설정", icon: <Settings fontSize="small" /> },
];

export const SYSTEM_GROUP: GroupMeta = { id: "system", title: "시스템", icon: <Memory fontSize="small" /> };

export const GROUP_MAP: Record<string, GroupMeta> = Object.fromEntries(SETTING_GROUPS.map((g) => [g.id, g]));

export const GROUP_TITLE: Record<string, string> = Object.fromEntries(SETTING_GROUPS.map((g) => [g.id, g.title]));
